import { render, staticRenderFns } from "./MemberCenterTips.vue?vue&type=template&id=04327dfd&scoped=true&"
import script from "./MemberCenterTips.vue?vue&type=script&lang=js&"
export * from "./MemberCenterTips.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterTips.vue?vue&type=style&index=0&id=04327dfd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04327dfd",
  null
  
)

export default component.exports